import React, { useEffect } from 'react';
import mystory1 from '../../images/mystory1.png';
import { background, motivation, experience } from './my-story-text';
import MyStorySecond from './MyStorySecond';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import bgSvg from '../../images/storysvgs/background.svg';
import motSvg from '../../images/storysvgs/motivation.svg';
import expSvg from '../../images/storysvgs/experience.svg';

gsap.registerPlugin(ScrollTrigger);
 
const MyStory = () => {
  useEffect(() => {
    let mm = gsap.matchMedia();

    mm.add('(min-width: 800px)', () => {
      let tlFull = gsap.timeline();
      tlFull.from('#t-c1', {
        opacity: 0,
        x: -100,
      });
      tlFull.from('#t-c2', {
        opacity: 0,
        y: 100,
      });
      tlFull.from('#t-c3', {
        opacity: 0,
        x: 100,
      });
      ScrollTrigger.create({
        trigger: '#my-story',
        start: 'top 20%',
        end: 'bottom bottom',
        scrub: true,
        animation: tlFull,
      });
    });

    mm.add('(max-width: 799px)', () => {
      let tlLarge = gsap.timeline();
      tlLarge.from('#t-c1', {
        opacity: 0,
        x: 100,
      });
      tlLarge.from('#t-c2', {
        opacity: 0,
        x: -100,
      });
      tlLarge.from('#t-c3', {
        opacity: 0,
        x: 100,
      });
      ScrollTrigger.create({
        trigger: '#my-story',
        start: 'top 50%',
        end: 'bottom bottom',
        scrub: true,
        animation: tlLarge,
      });
    });

    mm.add('(max-width: 599px)', () => {
      let tlMed = gsap.timeline();
      tlMed.from('#t-c1', {
        opacity: 0,
        x: 100,
      });
      tlMed.from('#t-c2', {
        opacity: 0,
        x: -100,
      });
      tlMed.from('#t-c3', {
        opacity: 0,
        x: 100,
      });
      ScrollTrigger.create({
        trigger: '#my-story',
        start: 'top bottom',
        end: 'bottom 105%',
        scrub: true,
        animation: tlMed,
      });
    });

    return () => {
      mm.revert();
    };
  }, []);

  return (
    <div>
      <div id="my-story">
        <div id="title">My Story</div>
        <div id="image">
          <img id="pic" src={mystory1} alt="valley"></img>
        </div>
        <div className="info-card" id="t-c1">
          <div className="card-title">
            <img className="icon-svg" src={bgSvg} alt="background icon" />
            Background
          </div>
          <p className="card-text">{background}</p>
        </div>
        <div className="info-card" id="t-c2">
          <div className="card-title">
            <img className="icon-svg" src={motSvg} alt="background icon" />
            Motivation
          </div>
          <p className="card-text">{motivation}</p>
        </div>
        <div className="info-card" id="t-c3">
          <div className="card-title">
            <img className="icon-svg" src={expSvg} alt="background icon" />
            Experience
          </div>
          <p className="card-text">{experience}</p>
        </div>
      </div>
      <div id="spacer"></div>
      <MyStorySecond />
    </div>
  );
};

export default MyStory;
